import axios from "axios";
import moment from "moment";
import { encodeUrlFromRouter, encodeUrlToRouter } from "@/routerUrlEncoding";
import syncRecordsSavedOffline from "@/employee/dm/syncDmRecords";
import dmTools from "@/employee/dm/dmTools";
import localDataFunc from "@/localDataFunctions";

//reconnection 5, disconnections 2
export default {
  name: "DmEditRecord",
  components: {
    CircleLoadingIndicator:
      require("@/customcontrols/circleLoadingIndicator/circleLoadingIndicator.vue")
        .default,
    BackButton: require("@/components/backButton/backButton.vue").default,
    DMComp: require("@/employee/dm/dm.vue").default,
    ErrorDialog:
      require("@/employee/captureMeterReadings/errorDisplayDialog/errorDisplayDialog.vue")
        .default,
    MapComp: require("@/employee/dm/debtManagementMap/debtManagementMap.vue")
      .default,
    SmsComp: require("@/components/adHocSms/adHocSms.vue").default,
  },
  mixins: [localDataFunc, dmTools],
  props: {},
  data: function () {
    return {
      existingMeterItems: [],
      displayType: { text: null, color: null, backgroundColor: null },
      enableSave: false,
      showMap: this.getFromLocal("dmShowMap") == true,
      isDmReadOnly: false,
      currRecord: {},
      showEditedRecordDialog: false,
      navigateSavedAction: { loc: null, seq: null },

      showDmComp: true,
      isLoading: false,
      selectedRecord: {
        batch: null,
        book: null,
        walk: null,
        sequence: null,
        billGroup: null,
        stage: null,
      },
      records: [],
      record: {},
      settings: {},
      geoLocation: null,
      geoLocationObj: { lat: 0, lng: 0, accuracy: 0 },
      onlineTimerCheck: null,
      navigatorConnection: { effectiveType: null, downlink: null },
      onLine: false,
      synchronizing: false,
      iscapturePicMadatory: false,
      showErrorDialog: false,
      errorsObject: { readings: [], sms: [], photos: [] },

      showPrintNotice: false,

      enableSendSmsButton: false,

      showSmsDialog: false,
    };
  },
  computed: {
    disableSaveButton: function () {
      //console.log("this.record.hasPic", this.record.hasPic);
      //console.log("this.iscapturePicMadatory", this.iscapturePicMadatory);
      //console.log("this.record.isSaved", this.record.isSaved);
      //console.log("this.record.status", this.record.status);
      //console.log("this.record.removeFromInvestigation", this.record.removeFromInvestigation);
      //console.log("this.getErrorClass(this.record)", this.getErrorClass(this.record));
      if (this.record.isSaved) return true;

      let res = false;

      if (
        this.record &&
        this.record.meterRef &&
        this.record.hasPic != true &&
        this.iscapturePicMadatory == true
      )
        res = true;

      if (this.getErrorClass(this.record) != "") res = true;

      if (
        !(
          (this.record.status === 3 &&
            this.record.removeFromInvestigation === true) ||
          this.record.status !== 3
        )
      )
        res = true;

      return this.enableSave ? false : res;
    },
    showCapturePhotoButton: function () {
      return (
        this.record.hasPic != true &&
        this.record.isSaved != true &&
        this.iscapturePicMadatory == true &&
        this.record.meterRef
      );
    },
    isNextButtDisabled: function () {
      if (!this.records || this.records.length == 0) return true;

      //find index in records array
      let index = this.records.findIndex((object) => {
        return object.sequence === this.record.sequence;
      });
      return index == this.records.length - 1;
    },
    isPreviousButtDisabled: function () {
      if (!this.records || this.records.length == 0) return true;

      //find index in records array
      const index = this.records.findIndex((object) => {
        return object.sequence === this.record.sequence;
      });
      return index == 0;
    },
    recordNumber: function () {
      let temp = this.records.findIndex(
        (r) => r.sequence === this.record.sequence
      );
      temp = temp ? temp + 1 : 1;
      return `${temp} / ${this.records.length}`;
    },
    getBackUrl: function () {
      return `debtManagementSelectRecord/${encodeUrlToRouter(
        this.selectedRecord.billGroup
      )}/${encodeUrlToRouter(this.selectedRecord.stage)}/${encodeUrlToRouter(
        this.selectedRecord.batch
      )}/${encodeUrlToRouter(this.selectedRecord.book)}/${encodeUrlToRouter(
        this.selectedRecord.walk
      )}`;
    },

    mapItems: function () {
      let items = [];
      this.records.forEach((r) => items.push(this.recordToMapItem(r)));

      return items;
    },
    mapItemSelected: function () {
      return this.recordToMapItem(this.record);
    },
  },
  watch: {
    onLine: function (value) {
      if (value) {
        this.$oldAlertMsg(this.$t("messages.online"), 1);
        this.saveOfflineReadings();
      } else {
        this.$oldAlertMsg(this.$t("messages.offline"), 1);
      }
    },
    "record.finalReading": function (value) {
      this.checkIfRecordIsEdited();
    },
    "record.finalReadingClockOver": function (value) {
      this.checkIfRecordIsEdited();
    },
    "record.finalReadingDate": function (value) {
      this.checkIfRecordIsEdited();
    },
    "record.removeMeter": function (value) {
      this.checkIfRecordIsEdited();
    },
    "record.installMeter": function (value) {
      this.checkIfRecordIsEdited();
    },
    "record.meterId": function (value) {
      this.checkIfRecordIsEdited();
    },
    "record.comment": function (value) {
      this.checkIfRecordIsEdited();
    },
    "record.comments": function (value) {
      this.checkIfRecordIsEdited();
    },
    "record.sequence": function (value) {
      if (!value) return;

      this.currRecord = { ...this.record };

      window.history.pushState(
        {},
        null,
        `/${this.$route.name}/${this.selectedRecord.billGroup}/${this.selectedRecord.stage}/${this.selectedRecord.batch}/${this.selectedRecord.book}/${this.selectedRecord.walk}/${this.record.sequence}`
      );

      this.flashBackground();
    },
    "record.onlyComments": function (value) {
      this.checkIfRecordIsEdited();

      if (!value) this.record.comment = this.currRecord.comment;

      this.enableSave = true;
    },
    "record.isUnderInvestigation": function (value) {
      this.checkIfRecordIsEdited();

      this.enableSave = true;
    },
    "record.removeFromInvestigation": function (value) {
      this.checkIfRecordIsEdited();

      this.enableSave = true;
    },
    "record.meterSerialNo": function (value) {
      this.checkIfRecordIsEdited();
    },

    showMap: function (value) {
      this.saveToLocal("dmShowMap", value);
    },
  },
  created() {
    window.addEventListener("online", this.updateOnlineStatus);
    window.addEventListener("offline", this.updateOnlineStatus);

    this.init();
  },
  mounted() {
    this.onLineTimerCheck = setInterval(async () => {
      await this.isConsideredOnline();
      this.navigatorConnection = {
        downlink: navigator["connection"]["downlink"],
        effectiveType: navigator["connection"]["effectiveType"],
      };
    }, 1000);
  },
  beforeDestroy() {
    window.removeEventListener("online", this.updateOnlineStatus);
    window.removeEventListener("offline", this.updateOnlineStatus);

    if (this.onLineTimerCheck != null) clearTimeout(this.onLineTimerCheck);
  },
  methods: {
    async init() {
      this.hasPic = false;
      this.isLoading = true;
      this.selectedRecord.billGroup = encodeUrlFromRouter(
        this.$route.params.billGroup
      );
      this.selectedRecord.stage = encodeUrlFromRouter(this.$route.params.stage);
      this.selectedRecord.batch = encodeUrlFromRouter(this.$route.params.batch);
      this.selectedRecord.book = encodeUrlFromRouter(this.$route.params.book);
      this.selectedRecord.walk = encodeUrlFromRouter(this.$route.params.walk);
      this.selectedRecord.sequence = encodeUrlFromRouter(
        this.$route.params.sequence
      );

      this.displayType = {
        text:
          this.selectedRecord.stage == 5
            ? `${this.$t("disconnections.EditReconnection")}`
            : this.selectedRecord.stage == 2
            ? `${this.$t("disconnections.EditDisconnection")}`
            : null,

        color:
          this.selectedRecord.stage == 5
            ? "color-blue-text"
            : this.selectedRecord.stage == 2
            ? "color-red-text"
            : null,

        backgroundColor:
          this.selectedRecord.stage == 5
            ? "background-light-blue"
            : this.selectedRecord.stage == 2
            ? "background-light-red"
            : null,
      };

      let temp = this.$store.getters.getSettings;
      this.showPrintNotice = temp.printNotice == true;

      temp = this.$store.getters.getUserProfile;
      this.enableSendSmsButton = temp.sendSmsSP == true;

      await this.getFromLocalDB("debtManagementSettings").then((resp) => {
        if (resp) this.settings = resp.settings;
      });

      this.iscapturePicMadatory =
        this.settings.meterReadingMandatoryCapturePhotoDm;

      this.isDmReadOnly =
        this.iscapturePicMadatory && this.record.meterRef ? true : false;

      this.getFromLocalDB(
        `dm_${this.selectedRecord.batch}_${this.selectedRecord.book}_${this.selectedRecord.walk}`
      )
        .then((resp) => {
          if (!resp) return;

          this.records = [...resp.records];
          this.records.forEach((r) => {
            if (!r.geoLocationObj || !r.geoLocationObj.lat)
              r["geoLocationObj"] = { lat: 0, lng: 0, accuracy: 0 };
          });

          let rec = this.records.filter(
            (r) => r.sequence == this.selectedRecord.sequence
          );
          let newDte = moment().add();

          if (
            !rec.isUnderInvestigation &&
            !rec.onlyComments &&
            moment(rec.finalReadingDate).isSameOrAfter(newDte)
          ) {
            rec.finalReadingDate = new Date();
          }

          if (rec[0].isAllowDisconReconWithoutReading == false)
            rec[0].onlyComments = false;

          this.record = rec[0];
          this.currRecord = { ...rec[0] };
        })
        .finally(() => (this.isLoading = false));

      var geoOptions = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      };

      var geo = navigator.geolocation.getCurrentPosition(
        (pos) => {
          this.geoLocation = pos;
          this.addGeoLocation();
        },
        (err) => {
          this.$alertMsg(err.message);
        },
        geoOptions
      );
    },
    async getFromLocalDB(id) {
      return this.$store.state.debtManagementLocalDB
        .get(id)
        .then((doc) => {
          return doc;
        })
        .catch((err) => {
          console.log("err", err);
          return null;
        });
    },
    isConsideredOnline(isOffline = false) {
      let navOnline = navigator.onLine;

      this.onLine =
        !isOffline &&
        navOnline &&
        (this.navigatorConnection.effectiveType === "3g" ||
          this.navigatorConnection.effectiveType === "4g");
      this.$store.commit("setCsAppsOfflineMode", { status: !this.onLine });

      //console.log("#", this.onLineCounter, " -- navigator.onLine", navOnline, "(", this.navigatorConnection.effectiveType, ") - onLine", this.onLine);
    },

    async addRecordForSave() {
      if (
        this.record.bInvalid === true &&
        this.settings.isAllowDisconReconWithoutReading == false
      ) {
        this.$oldAlertMsg(this.$t("dms.SavingNotAllowedWithoutReading"), 3);
        return;
      }

      this.record["isRemoveInstallMeter"] = this.settings.isRemoveInstallMeter;
      this.record["isSynced"] = false;
      this.record["geoLocationObj"] = { ...this.geoLocationObj };
      this.record.isSaved = true;
      this.record.isEdited = false;

      if (!this.record.finalReadingDate)
        this.record.finalReadingDate = moment().format();

      if (
        this.record.status !== 3 &&
        this.record.isUnderInvestigation &&
        this.record.onlyComments
      ) {
        if (this.record.finalReadingClockOver === null)
          this.record.finalReadingClockOver = false;
      }

      let id = `dm_${this.selectedRecord.batch}_${this.selectedRecord.book}_${this.selectedRecord.walk}`;
      await this.$store.state.debtManagementLocalDB
        .get(id)
        .then((doc) => {
          doc.records.push(this.record);

          this.$store.state.debtManagementLocalDB
            .put({
              _id: doc._id,
              _rev: doc._rev,
              batchId: this.selectedRecord.batch,
              bookId: this.selectedRecord.book,
              walkId: this.selectedRecord.walk,
              records: this.records,
            })
            .then((resp) => {
              id = `dm_recsToSync`;
              this.$store.state.debtManagementLocalDB
                .get(id)
                .then((doc) => {
                  doc.records.push(this.record);

                  this.$store.state.debtManagementLocalDB
                    .put({
                      _id: doc._id,
                      _rev: doc._rev,
                      batchId: this.selectedRecord.batch,
                      bookId: this.selectedRecord.book,
                      walkId: this.selectedRecord.walk,
                      records: doc.records,
                    })
                    .then((resp) => {
                      this.record.isEdited = false;
                      this.$oldAlertMsg(
                        this.$t("disconnections.RecordSaved"),
                        2
                      );
                      this.saveOfflineReadings();
                    });
                })
                .catch((err) => {
                  if (err.status == 404) {
                    this.$store.state.debtManagementLocalDB
                      .put({
                        _id: id,
                        batchId: this.selectedRecord.batch,
                        bookId: this.selectedRecord.book,
                        walkId: this.selectedRecord.walk,
                        records: [this.record],
                      })
                      .then((resp) => {
                        this.record.isEdited = false;
                        this.$oldAlertMsg(
                          this.$t("disconnections.RecordSaved"),
                          2
                        );
                        this.saveOfflineReadings();
                      });
                  }
                });
            });
        })
        .catch((err) => {});
    },
    async addPicForSave(picData) {
      if (!picData) return;

      picData["isSynced"] = false;
      picData["meterRef"] = this.record.meterRef;
      picData["propertyAddress"] = this.record.address;

      const id = `dm_picsToSync`;
      await this.$store.state.debtManagementLocalDB
        .get(id)
        .then((doc) => {
          doc.pictures.push(picData);

          this.$store.state.debtManagementLocalDB
            .put({
              _id: doc._id,
              _rev: doc._rev,
              batchId: this.selectedRecord.batch,
              bookId: this.selectedRecord.book,
              walkId: this.selectedRecord.walk,
              pictures: doc.pictures,
            })
            .then((resp) => {
              this.record.hasPic = true;
              this.isDmReadOnly = false;
              this.saveOfflineReadings();
            });
        })
        .catch((err) => {
          if (err.status == 404) {
            this.$store.state.debtManagementLocalDB
              .put({
                _id: id,
                batchId: this.selectedRecord.batch,
                bookId: this.selectedRecord.book,
                walkId: this.selectedRecord.walk,
                pictures: [picData],
              })
              .then((resp) => {
                this.record.hasPic = true;
                this.isDmReadOnly = false;
                this.saveOfflineReadings();
              });
          }
        });
    },
    async addSmsForSave() {
      let msg = {
        caseId: this.record.caseId,
        account: this.record.account,
        isSynced: false,
      };

      const id = `dm_smsToSync`;
      await this.$store.state.debtManagementLocalDB
        .get(id)
        .then((doc) => {
          doc.sms.push(msg);

          this.$store.state.debtManagementLocalDB
            .put({
              _id: doc._id,
              _rev: doc._rev,
              caseId: this.record.caseId,
              account: this.record.account,
              sms: doc.sms,
            })
            .then((resp) => {
              this.$oldAlertMsg(this.$t("disconnections.RecordSaved"), 2);
              this.saveOfflineReadings();
            });
        })
        .catch((err) => {
          if (err.status == 404) {
            this.$store.state.debtManagementLocalDB
              .put({
                _id: id,
                caseId: this.record.caseId,
                account: this.record.account,
                sms: [msg],
              })
              .then((resp) => {
                this.$oldAlertMsg(this.$t("disconnections.RecordSaved"), 2);
                this.saveOfflineReadings();
              });
          }
        });
    },
    async addAdHocSmsForSave(message) {
      let msg = {
        message: message,
        account: this.record.account,
        isSynced: false,
      };

      const id = `dm_adHoc_smsToSync`;
      await this.$store.state.debtManagementLocalDB
        .get(id)
        .then((doc) => {
          doc.adHocSms.push(msg);

          this.$store.state.debtManagementLocalDB
            .put({
              _id: doc._id,
              _rev: doc._rev,
              message: message,
              account: this.record.account,
              adHocSms: doc.adHocSms,
            })
            .then((resp) => {
              this.$oldAlertMsg(this.$t("disconnections.RecordSaved"), 2);
              this.saveOfflineReadings();
            });
        })
        .catch((err) => {
          if (err.status == 404) {
            this.$store.state.debtManagementLocalDB
              .put({
                _id: id,
                message: message,
                account: this.record.account,
                adHocSms: [msg],
              })
              .then((resp) => {
                this.$oldAlertMsg(this.$t("disconnections.RecordSaved"), 2);
                this.saveOfflineReadings();
              });
          }
        });
    },

    addGeoLocation() {
      if (this.geoLocation != null) {
        this.geoLocationObj.accuracy = this.geoLocation.coords.accuracy;
        this.geoLocationObj.lat = this.geoLocation.coords.latitude;
        this.geoLocationObj.lng = this.geoLocation.coords.longitude;
      } else {
        this.geoLocationObj.accuracy = 0;
        this.geoLocationObj.lat = 0;
        this.geoLocationObj.lng = 0;
      }
    },

    sendSmsDialog() {
      this.displaySendSmsDialog = !this.displaySendSmsDialog;
    },

    async saveOfflineReadings() {
      if (this.onLine) {
        this.synchronizing = true;

        let db = this.$store.state.debtManagementLocalDB;
        this.errorsObject = await syncRecordsSavedOffline(db, this.settings);

        if (
          this.errorsObject.sms.length > 0 ||
          this.errorsObject.readings.length > 0 ||
          this.errorsObject.photos.length > 0
        )
          this.showErrorDialog = true;

        this.synchronizing = false;
      }
    },

    async save() {
      if ((await this.checkIfPhotoUploaded()) == false) {
        return;
      }
    },

    printNotice() {
      let parameter = {
        AccountNo: this.record.account,
        CaseId: this.record.caseId,
        ConnectionId: this.record.connectionId,
        EscPosData: true,
        ProfileId: this.settings.profileId,
      };

      axios
        .post("/DmConnection/GetDiscReconnNoticeSp", parameter)
        .then((response) => {
          if (response.status == 200) {
            this.printReceipt(response.data.escPosData);
          } else {
            this.$alertMsg(response.data.Message, 4);
          }
        })
        .catch((e) => {
          this.$alertMsg(e.message, 4);
        });
    },
    printReceipt(printStr) {
      var S = "#Intent;scheme=rawbt;";
      var P = "package=ru.a402d.rawbtprinter;end;";
      var textEncoded = "base64," + printStr;
      //window.location.href = "intent:" + textEncoded + S + P;
      window.open("intent:" + textEncoded + S + P);
      //printing is done with 3d party app on android
      // https://rawbt.ru/start.html
    },

    openCapturPicDialog() {
      this.$root.$emit("open_upload_picture_attachment_dialog", true);
    },

    editedRecordDialogActions(action) {
      if (action == "navigate") {
        let indx = this.records.findIndex(
          (r) => r.sequence == this.record.sequence
        );

        if (indx != null) this.records[indx] = { ...this.currRecord };

        this.record = { ...this.currRecord };
        this.record.isEdited = false;
        this.navigation(
          this.navigateSavedAction.loc,
          this.navigateSavedAction.seq
        );
      }

      this.showEditedRecordDialog = false;
    },
    navigation(loc, seq = null) {
      this.navigateSavedAction = { loc: null, seq: null };

      if (this.record.isEdited) {
        this.showEditedRecordDialog = true;
        this.navigateSavedAction = { loc: loc, seq: seq };
        return;
      }

      let index;

      if (loc == "to" && seq)
        index = this.records.findIndex((object) => object.sequence == seq);
      else
        index = this.records.findIndex(
          (object) => object.sequence == this.record.sequence
        );

      if (loc == "next") {
        index++;
      } else if (loc == "previous") {
        index--;
      }

      if (index >= this.records.length || index < 0) return;

      if (this.records[index].isAllowDisconReconWithoutReading == false)
        this.records[index].onlyComments = false;

      this.record = this.records[index];
      this.enableSave = false;

      this.isDmReadOnly =
        this.iscapturePicMadatory && this.record.meterRef ? true : false;

      this.$root.$emit("dm_updated");
      this.$root.$emit("update_selected_marker");
      this.record.isEdited = false;
    },
    checkIfRecordIsEdited() {
      if (this.record.sequence != this.currRecord.sequence) return;

      Object.keys(this.record).forEach((key) => {
        const value = this.record[key];
        const value1 = this.currRecord[key];

        if (value != value1 && typeof value != "object")
          this.record.isEdited = true;
      });
    },
    flashBackground() {
      let elem = document.getElementById("dm_card");

      if (elem == null || elem.style == null) return;

      let s = elem.style;
      let loops = 100;

      let timer = setInterval(function () {
        s.backgroundColor = "rgb(" + loops + "," + loops + "," + loops + ",1)";

        loops += 10;
        if (loops > 255) {
          s.backgroundColor = "#FCFFFF";
          clearInterval(timer);
        }
      }, 40);
    },

    // map functions
    isGreenIcon(item) {
      return item.stage == 5 ? true : false;
    },
    isRedIcon(item) {
      return item.stage == 2 ? true : false;
    },
    recordToMapItem(record) {
      return {
        account: record.account,
        address: record.address,
        coordX: record.coordX,
        coordY: record.coordY,
        gpsX: record.gpsX,
        gpsY: record.gpsY,
        meterSerialNo: record.meterSerialNo,
        meterRef: record.meterRef,
        sequence: record.sequence,
        stage: record.stage,
      };
    },
    selectedItemChanged(item) {
      //console.log("djjdd", item, this.records.filter(r => r.sequence == item));

      this.navigation("to", item);
      this.$forceUpdate();
    },
  },
};
